<div class="sidebar" role="navigation" style="background-color: #e3eaf3;">
  <div class="sidebar-nav navbar-collapse">
    <ul class="nav" id="side-menu">
      <app-menu-item route="/dashboard" name="Dashboard" icon="fa-dashboard"></app-menu-item>
      <app-menu-item route="/site/list" name="Sites" icon="fa-map-marker" [params]="{dataset: ''}"
                     [subItems]="[{name: 'Beaches', route: '/site/list', params: {'dataset': 'beach', search: null}},
                     {name: 'Brownfields', route: '/site/list', params: {'dataset': 'brownfields', search: null}},
                     {name: 'Emergency Response', route: '/site/list', params: {'dataset': 'er_site', search: null}},
                     {name: 'FUDS', route: '/site/list', params: {'dataset': 'fuds', search: null}},
                     {name: 'One Stop', route: '/site/list', params: {'dataset': 'onestop', search: null}},
                     {name: 'Pesticides', route: '/site/list', params: {dataset: 'pesticides', search: null}},
                     {name: 'Pre-CERCLIS', route: '/site/list', params: {'dataset': 'precerclis', search: null}},
                     {name: 'Solid Waste', route: '/site/list', params: {'dataset': 'solidwaste', search: null}},
                     {name: 'Standby Generators', route: '/site/list', params: {'dataset': 'standby', search: null}},
                     {name: 'Storage Tanks', route: '/site/list', params: {'dataset': 'ust', search: null}},
                     {name: 'Tier II', route: '/site/list', params: {'dataset': 'tierii', search: null}}]"></app-menu-item>
      <app-menu-item route="/maptool" name="Map Tool" icon="fa-globe"></app-menu-item>
      <app-menu-item name="Beaches" icon="fa-tint" id="beachMenu"
                     [subItems]="[{name: 'Dashboard', route: '/beach/dashboard'},
                     {name: 'Sampling Entry', route: '/beach/sampling'},
                     {name: 'Results Entry', route: '/beach/results'},
                     {name: 'Advisory Entry', route: '/beach/advisory'},
                     {name: 'Status Review', route: '/beach/status'},
                     {name: 'Submissions', route: '/beach/submission/list'},
                     {name: 'Reports', route: '/beach/reports'},
                     {name: 'Organization Info', route: '/beach/organization'}]">
      </app-menu-item>
      <app-menu-item name="Storage Tanks" route="/storagetanks/reports" icon="fa-flask"></app-menu-item>
      <app-menu-item name="Solid Waste" route="/solidwaste" icon="fa-trash"></app-menu-item>
      <app-menu-item name="Complaints" route="/complaints/list" icon="fa-comment"></app-menu-item>
      <app-menu-item name="Permit Submissions" icon="fa-file"
                     [subItems]="[{name: 'Standby Generators', route: '/applications/standby', params: {ordering: '-status_date'}},
                     {name: 'Standby Annual Reports', route: '/applications/standbyannualreports'},
                     {name: 'Pesticide NOAs', route: '/applications/pesticides'}
                     ]"></app-menu-item>
      <app-menu-item name="Permits" icon="fa-check-square-o"
                     [subItems]="[
                     {name: 'Dashboard', route: '/permit/dashboard'},
                     {name: 'Review Queue', route: '/permit/review', params: {
                        current_user: true,
                        is_next: true,
                        all_permits:false,
                        status__terms: 'needed__in_review',
                        sub_type: null,
                        content_type: null,
                        current_status__terms: null,
                        ordering: '-submission_date',
                        next_reviewer: null
                     }},
                     {name: 'Permit Queue', route: '/permit/listall', params: {
                        current_user: false,
                        is_next: null,
                        all_permits: true,
                        current_status__terms: 'needed__in_review',
                        status__terms: null,
                        sub_type: null,
                        content_type: null,
                        ordering: 'submission_date',
                        next_reviewer: null
                     }},
                     {name: 'On Hold/Rejected', route: '/permit/listall', params: {
                        current_user: false,
                        is_next: false,
                        all_permits: true,
                        current_status__terms: 'rejected',
                        status__terms: null,
                        ordering: '-submission_date',
                        sub_type: null,
                        content_type: null,
                        next_reviewer: null
                     }}
                     ]"></app-menu-item>
      <app-menu-item name="Permit Notification" icon="fa-envelope-o"
                     [subItems]="[{name: 'One Stop', route: '/permit/notification/onestop'},
                                  {name: 'Standby', route: '/permit/notification/standby'}]"></app-menu-item>
      <!--      <app-menu-item name="Standby Generators" icon="fa-bolt" route="/standby"-->
      <!--                     [subItems]="[]"></app-menu-item>-->
      <app-menu-item route="/foia-search" name="FOIA Search" icon="fa-map-pin"></app-menu-item>
      <app-menu-item route="/help" name="Help" icon="fa-question-circle"
                     [subItems]="[{name: 'Introduction', route: '/help', framement: 'intro'},
                                           {name: 'Dashboard', route: '/help', fragment: 'dashboard'},
                                           {name: 'Site List', route: '/help', fragment: 'site list'},
                                           {name: 'Site', route: '/help', fragment: 'site'},
                                           {name: 'Map Tool', route: '/help', fragment: 'map tool'}]">
      </app-menu-item>
      <app-menu-item route="/dww" name="Drinking Water Watch" icon="fa-glass"></app-menu-item>
      <app-menu-item route="/contactmanager" name="Contact Manager" icon="fa-users"></app-menu-item>
    </ul>
  </div>
  <!-- //sidebar-collapse -->
</div>
